import * as React from 'react';
import {
  Create,
  SimpleForm,
} from 'react-admin';
import ClassicalContentForm from './ClassicalContentForm';
import FormToolbar from '../shared/FormToolbar';

const ClassicalContentEdit = props => (
  <Create {...props}>
    <SimpleForm
      toolbar={<FormToolbar />}
      redirect="list"
    >
      <ClassicalContentForm {...props} />
    </SimpleForm>
  </Create>
);

export default ClassicalContentEdit;
